import { Component, Input } from '@angular/core';
import { ICashFlowTotal } from '@modeso/types__aumico-lib-annualreport-be';
import { I18NextService } from 'angular-i18next';
import { localizationKeys } from '../../../constants/localizationKeys';

@Component({
    selector: 'aumico-annualReport-cash-flow-total-from-activities-component',
    templateUrl: 'cash-flow-total-from-activities.component.html',
    styleUrls: ['cash-flow-total-from-activities.component.scss'],
})
export class CashFlowTotalFromActivitiesComponent {
    @Input() currentTotal: number;
    @Input() previousTotal: number;
    @Input() numberFormat = '1.2-2';
    @Input() reportLocale: string;

    @Input() operatingCurrent: number;
    @Input() operatingPrevious: number;
    @Input() investingCurrent: number;
    @Input() investingPrevious: number;
    @Input() financingCurrent: number;
    @Input() financingPrevious: number;
    
    
    private savedTotalName: string;

    @Input() set savedTotal(value: ICashFlowTotal) {
        this.savedTotalName = value?.total1;
    }

    get totalName(): string {
        if (this.savedTotalName) {
            return this.savedTotalName;
        }
        return this.i18n.t(this.local.aumico_annual_report_cash_flow_total_total1_name, { lng: this.reportLocale }) as string;
    }

    get totalIndex(): string {
        return this.i18n.t(this.local.aumico_annual_report_cash_flow_total_total1, { lng: this.reportLocale }) as string;
    }

    get operatingLabel(): string {
        return this.i18n.t(this.local.aumico_annual_report_cash_flow_operating_activities_title, { lng: this.reportLocale }) as string;
    }
    get investingLabel(): string {
        return this.i18n.t(this.local.aumico_annual_report_cash_flow_investing_activities_title, { lng: this.reportLocale }) as string;
    }
    get financingLabel(): string {
        return this.i18n.t(this.local.aumico_annual_report_cash_flow_financing_activities_title, { lng: this.reportLocale }) as string;
    }

    constructor(private i18n: I18NextService) {}

    private local = localizationKeys;

    onTitleChange(newTitle: string): void {
        this.savedTotalName = newTitle;
    }

    getTitle(): string {
        return this.totalName;
    }
}